import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { FileExtensionPreview } from "@air/component-file-extension-preview";
import classNames from "classnames";
import { memo } from "react";
import { AssetGalleryCardMetaDetails } from "~/components/Gallery/AssetGalleryCard/AssetGalleryCardMetaDetails";
import { useUploadingData } from "~/components/Upload/hooks/useUploadingData";
import { UPLOADING_ASSET } from "~/constants/testIDs";
import { useHover } from "~/hooks/useHover";
import { isTitleAndMetadataVisibleSelector } from "~/store/configViews/selectors";
import { useAirSelector } from "~/utils/ReduxUtils";
export const UploadingAssetGalleryCard = /*#__PURE__*/ memo((param)=>{
    let { upload, width, getClassName } = param;
    const { apiUploadData: { ext, size, importedName } } = upload;
    const { stateText } = useUploadingData(upload);
    const isTitleAndMetadataVisible = useAirSelector(isTitleAndMetadataVisibleSelector);
    const { handleHover, handleUnhover, isHovering } = useHover();
    const title = importedName || "Untitled";
    return /*#__PURE__*/ _jsxs("div", {
        "data-testid": UPLOADING_ASSET,
        "data-asset-title": title,
        onMouseEnter: handleHover,
        onMouseMove: handleHover,
        onMouseLeave: handleUnhover,
        className: "relative flex h-full flex-col",
        children: [
            /*#__PURE__*/ _jsx("div", {
                className: classNames("absolute cursor-default rounded-4 border-2 border-transparent", isHovering && "bg-pigeon-50", getClassName === null || getClassName === void 0 ? void 0 : getClassName({
                    isHovering
                })),
                style: {
                    inset: -6
                }
            }),
            /*#__PURE__*/ _jsxs("div", {
                className: "relative flex grow items-center justify-center",
                children: [
                    /*#__PURE__*/ _jsx("div", {
                        className: "absolute inset-0 flex flex-col rounded-4 bg-pigeon-100"
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: "relative",
                        children: /*#__PURE__*/ _jsx(FileExtensionPreview, {
                            ext: ext,
                            text: stateText,
                            color: "gray",
                            size: "medium",
                            className: "grow justify-center"
                        })
                    }),
                    !isTitleAndMetadataVisible && !!size && /*#__PURE__*/ _jsx("div", {
                        className: classNames("absolute bottom-0 left-0 right-0 rounded-4 rounded-t-none bg-black/70 px-2 pb-2 pt-1", isHovering ? "opacity-100" : "opacity-0"),
                        children: /*#__PURE__*/ _jsx(AssetGalleryCardMetaDetails, {
                            hasDarkBackground: true,
                            clip: {
                                ext,
                                size
                            },
                            title: title,
                            /** Card width minus the left and right padding */ width: width - 16
                        })
                    })
                ]
            }),
            isTitleAndMetadataVisible && !!size && /*#__PURE__*/ _jsx("div", {
                className: "relative",
                children: /*#__PURE__*/ _jsx(AssetGalleryCardMetaDetails, {
                    clip: {
                        ext,
                        size
                    },
                    title: title,
                    /** Card width minus the left and right padding */ width: width - 4
                })
            })
        ]
    });
});
UploadingAssetGalleryCard.displayName = "UploadingAssetGalleryCard";
